var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors } from "@wrstudios/theme";
export var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n"], ["\n  display: block;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n"])));
export var Grid = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin: -0.2rem;\n"], ["\n  display: flex;\n  margin: -0.2rem;\n"])));
export var Cell = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  padding: 0.1rem;\n"], ["\n  display: block;\n  width: 100%;\n  padding: 0.1rem;\n"])));
export var Image = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  height: 7rem;\n  background: ", " center center / cover no-repeat;\n"], ["\n  display: block;\n  width: 100%;\n  height: 7rem;\n  background: ", " center center / cover no-repeat;\n"])), colors.gray[400]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;